import WhiteStarIcon from "@Icons/WhiteStarIcon";
import classes from "./ReviewCaptionStyles.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const ReviewCaption = ({ userName, rating }: any) => (
  <div className={classes.captionComponentSection}>
    <div className={classes.name}>{userName}</div>
    <div className={classes.rating}>
      {rating}
      <WhiteStarIcon />
    </div>
  </div>
);

export default wrapperHOC(ReviewCaption, {
  componentName: "ReviewCaption-ReviewsSection-PropertyPage",
  showForChina: true,
});
